export default __webpack_public_path__ + "static/media/ico-blog.b2697e2e.webp";